<template>
  <div class="my-work-order">
    <div class="work-order-wrap">
      <div class="service-entry">
        <template v-if="!hasEntry">
          <div class="common-entry" @click="hasEntry = true">
            <img src="./images/service.png" alt="" />
            <div class="work-order-remind">
              <div v-if="newNoticeNum > 0" class="remind-text order-new">工单新进度</div>
              <div v-if="newCustomerNoticeNum > 0" class="remind-text service-new">客服新留言</div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="active-entry">
            <img src="./images/service-active.png" @click="closeEntryService" alt="" />
            <ul class="service-list">
              <li class="my-order order-item" @click="checkOrderList">
                <span>我的工单</span>
                <div class="remind-text" v-show="newNoticeNum > 0">新进度</div>
              </li>
              <li class="my-service order-item" @click="openService">
                <span>我的客服</span>
                <div v-if="newCustomerNoticeNum > 0" class="remind-text">新留言</div>
              </li>
            </ul>
            <div class="service-detail-list" v-if="orderListFlag">
              <OrderList :appType="appType" @closeMyOrderList="closeMyOrderList"/>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import OrderList from "./orderList.vue";
import YSF from "@neysf/qiyu-web-sdk";
import { queryWorkSheetUnReadCount, queryCustomerSheetUnReadCount, updateCustomerSheetRead } from "./apis";
export default {
  props: {
    appType: {
      type: String,
      default: 'agent',
    },
  },
  components: {
    OrderList,
  },

  data() {
    return {
      orderListFlag: false,
      hasEntry: false, //是否点击客服入口
      pageIndex: 1, //完结工单当前页码
      pageSize: 10,
      newNoticeNum: 0,
      newCustomerNoticeNum: 0, //客服未读消息数
      myOrderDialog: false, //我的工单弹框
      qiyu: null, //七鱼客服
      listData: [],
      dataCount: 0,
      activeName: "finished",
      orderDetialDialog: false,
      userInfo: {},
    };
  },
  computed: {
    // 判断是否为教师类型
    isTeacher() {
      return this.appType === 'teacher';
    },
    // 判断是否为代理商类型
    isAgent() {
      return this.appType === 'agent';
    },
    // 获取用户信息存储的key
    userInfoKey() {
      return this.isTeacher ? 'teacher_info' : `${this.appType}_user_info`;
    },
    // 获取额外的请求参数（教师类型需要添加type:1）
    extraParams() {
      return this.isTeacher ? { type: 1 } : {};
    },
  },
  methods: {
    // 我的工单 x号，父传子
    closeMyOrderList(){
      this.orderListFlag= false
      this.queryWorkSheetUnReadCount()
    },
    // 点击图标关闭我的客服
    closeEntryService(){
        this.hasEntry = false
        this.orderListFlag = false
    },
    // 查看工单列表
    checkOrderList() {
      this.orderListFlag = true;
    },
    getAgentInfo() {
      const userInfo = this.userInfo || {};
      const ssoCampusInfo = JSON.parse(localStorage.getItem('sso_campus_info') || '[]');
      
      // 获取用户ID
      const userId = ssoCampusInfo.length > 0 ? ssoCampusInfo[0].userId : '';
      const uid = userId || userInfo.id;
      
      // 获取组织ID列表
      const organizationIds = ssoCampusInfo.length > 0 
        ? ssoCampusInfo.map(item => item.campusId)
        : [userInfo.campusId];
      
      // 获取组织信息
      const organizationId = userInfo.campusId;
      const organizationType = this.isAgent ? '经销商' : '代理商';
      const organizationLevel = userInfo.position === 6008001 ? '主账号' : '子账号';
      
      // 获取用户基本信息
      const name = userInfo.trueName || '';
      const mobile = userInfo.mobile || '';

      return {
        uid,
        name,
        mobile,
        organizationId,
        organizationIds,
        organizationType,
        organizationLevel,
      };
    },
    getTeacherInfo () {
      const userInfo = this.userInfo || {};
      const ssoCampusInfo = userInfo.account_list || [];

      // 获取用户ID
      const uid = userInfo.teacher_id;
      // 获取组织ID列表
      const organizationIds = ssoCampusInfo.length > 0 
        ? ssoCampusInfo.map(item => item.school_id)
        : [userInfo.school_id];
      
      // 获取组织信息
      const organizationId = userInfo.school_id;
      const organizationType = '分析师';
      const organizationLevel = '';
      
      // 获取用户基本信息
      const accountInfo =
        JSON.parse(localStorage.getItem('account_list')) || {};
      const name = userInfo.real_name || '';
      const mobile = userInfo.phone || accountInfo.phone || '';

      return {
        uid,
        name,
        mobile,
        organizationId,
        organizationIds,
        organizationType,
        organizationLevel,
      };
    },
    // 初始化七鱼客服
    initQiYu() {
      /**
       * 第一个参数是 企业 appkey
       * 第二个参数是 配置参数
       */
      const {
        uid, name, mobile,
        organizationId,
        organizationIds,
        organizationType,
        organizationLevel,
      } = this.isTeacher ? this.getTeacherInfo() : this.getAgentInfo();

      // 构建基础数据
      const data = [
        { key: "key1", label: "名字", value: name },
        { key: "key2", label: "手机", value: mobile },
        {
          key: "key3",
          label: "客户当前访问账号组织ID",
          value: organizationId,
        },
        {
          key: "key4",
          label: "客户访问账号组织性质",
          value: organizationType,
        },
        {
          key: "key5",
          label: "客户访问账号级别",
          value: organizationLevel,
        },
        {
          key: "key6",
          label: "客户访问账号全部组织ID",
          value: organizationIds.toString(),
        },
      ];

      // 如果是老师账号，添加分析师账号信息
      if (this.isTeacher) {
        data.push({ key: "key7", label: "分析师账号", value: this.userInfo.uname });
      }

      const options = {
        uid,
        data: JSON.stringify(data),
        layerSize: {
          width:650,
          height:650,
        }
      };
      return new Promise((resolve, reject) => {
        YSF.init("deb4cf6b9b8be27685aa179e7d86c16d", {
          hidden: 1,
        })
          .then((ysf) => {
            ysf("config", options);
            this.qiyu = ysf;
          })
          .catch((error) => {
            console.log("sdk加载失败---", error);
            this.$message.error("我的客服加载失败");
          })
          .finally(() => {
            resolve();
          });
      });
    },
    // 点击我的客服进行会话
    async openService() {
      if (!this.qiyu) {
        await this.initQiYu();
      }
      if (this.qiyu) {
        this.qiyu("open", {
          templateId: 4463292,
        });
        this.qiyu("onunread", (res) => {
          this.newCustomerNoticeNum = parseInt(res.total || 0);
        });
        this.updateCustomerSheetRead(); // 更新客服消息已读
      }
    },
    // 获取基础请求参数
    getBaseParams() {
      const userId = this.userInfo[this.isTeacher ? 'teacher_id' : 'id'];
      return {
        param: { 
          userId,
          ...this.extraParams
        }
      };
    },
    // 处理API响应
    handleApiResponse(response, callback) {
      if (response.code == 0 && callback) {
        callback(response.data);
      }
    },
    // 获取是否有新的工单进展
    queryWorkSheetUnReadCount() {
      const params = this.getBaseParams();
      queryWorkSheetUnReadCount(params).then((res) => {
        this.handleApiResponse(res, (data) => {
          this.newNoticeNum = parseInt(data || 0);
        });
      });
    },
    // 获取客服未读消息数
    queryCustomerSheetUnReadCount() {
      const params = this.getBaseParams();
      queryCustomerSheetUnReadCount(params).then((res) => {
        this.handleApiResponse(res, (data) => {
          this.newCustomerNoticeNum = parseInt(data || 0);
        });
      });
    },
    updateCustomerSheetRead() {
      const params = this.getBaseParams();
      updateCustomerSheetRead(params).then((res) => {
        this.handleApiResponse(res, (data) => {
          this.newCustomerNoticeNum = 0;
        });
      });
    },
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem(this.userInfoKey) || '{}');
  },
  mounted() {
    this.queryWorkSheetUnReadCount();
    this.queryCustomerSheetUnReadCount();
  },
};
</script>

<style lang="scss" scoped>
.work-order-wrap {
  position: fixed;
  bottom: 40px;
  right: 24px;
  z-index: 100;
  .service-entry {
    img {
      display: block;
      width: 88px;
      height: 88px;
    }
    .common-entry {
      position: relative;
      .work-order-remind {
        position: absolute;
        display: block;
        top: 10px;
        left: -60px;
        .remind-text {
          height: 20px;
          line-height: 20px;
          padding: 0 12px;
          margin-bottom: 4px;
          font-size: 12px;
          color: #fff;
          background: #FF4A46;
          border-radius: 10px;
          &:first-child {
            border-bottom-right-radius: 0px;
          }
          &:last-child {
            border-top-right-radius: 0px;
          }
          &:only-child {
            border-bottom-right-radius: 0px;
            border-top-right-radius: 10px;
          }
        }
        .order-new {
          background: #FF4A46;
        }
        .service-new {
          background: #FFA500;
        }
      }
    }
    .active-entry {
      position: relative;
      .service-list {
        width: 188px;
        height: 152px;
        background: #ffffff;
        box-shadow: 0px 6px 12px 0px rgba(68, 75, 101, 0.12);
        border-radius: 18px;
        position: absolute;
        bottom: 18px;
        right: 108px;
        cursor: pointer;
        .order-item {
          height: 50%;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 22px;
          color: #333333;
          line-height: 30px;
          font-style: normal;
          .remind-text {
            position: absolute;
            right: 24px;
            top: 6px;
            height: 20px;
            line-height: 20px;
            padding: 0 12px;
            font-size: 12px;
            color: #fff;
            border-radius: 10px 10px 10px 0px;
            background: #FF4A46;
          }
        }
        .my-order .remind-text {
          background: #FF4A46;
        }
        .my-service .remind-text {
          background: #FFA500;
        }
      }
      .service-detail-list {
        position: absolute;
        bottom: 18px;
        right: 108px;
        width: 630px;
        background: #ffffff;
        box-shadow: 0px 6px 12px 0px rgba(68, 75, 101, 0.12);
        border-radius: 18px;
        padding: 16px;
      }
    }
  }
}
.my-order-wrap {
  // max-height: 50vh;
  // overflow-y: scroll;
  .order-list {
    .detail-edit-wrap {
      position: relative;

      .new-tip {
        position: absolute;
        width: 12px;
        height: 12px;
        background: #ff4757;
        border-radius: 50%;
        top: 10px;
      }
    }
  }
}
.order-detail-wrap {
  max-height: 50vh;
  overflow-y: scroll;
  padding: 0 30px;
  h3 {
    text-align: center;
    font-size: 16px;
  }
  .order-info {
    table {
      margin-top: 20px;
      tr {
        padding: 20px;
        height: 30px;
      }
      .tip {
        width: 240px;
      }
    }
  }
  .order-result {
    .text-wrap {
      margin-top: 20px;
    }
    .file-wrap {
      margin-top: 20px;
      padding: 0 30px;
      display: grid;
      grid-template-columns: repeat(3, 33%);
      .file-item {
        padding: 5px;
      }
    }
  }
}
</style>